import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableActions',
  props: {
    class: {},
    data: {}
  },
  setup(__props: any) {

    const props = __props;

    const key = () => {
        return JSON.stringify(props.data);
        // return `${props.data.id}-${props.data.updated_at}`; // Less memory usage but not sure we can rely on updated_at
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    key: key(),
    class: _normalizeClass(_unref(cn)('flex items-center gap-1', props.class)),
    "data-action": ""
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})